import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';
import * as moment from 'moment';
import { AppConfigService } from '../../app-config.service';

@Pipe({
  name: 'hour',
  standalone: false
})
export class HourPipe implements PipeTransform {
  private readonly FR_FORMAT = 'H [h]';
  private readonly EN_FORMAT = 'h A';

  constructor(private readonly _appConfigService: AppConfigService) {}

  transform(
    date: string | Date,
    langue: string = get(this._appConfigService, 'configData.contexteEnvironnement.langue', 'fr')
  ): any {
    moment.locale(langue);
    let formattedHour = '-';

    if (date) {
      formattedHour = moment(date)
        .format(langue === 'fr' ? this.FR_FORMAT : this.EN_FORMAT)
        .replace('am', 'AM')
        .replace('pm', 'PM');
    }

    return formattedHour;
  }
}
